import {
  FlexCenteredContainer,
  MarginRightSpan,
  MarginTopProgressBar,
} from "@/react/features/smp/licenses/components/styled";

export function LicensePoolUsage({ licensePool }) {
  const unassigned =
    licensePool.quantity - (licensePool.inUse + licensePool.suspended);
  const quantity = licensePool.quantity;
  return (
    <FlexCenteredContainer>
      <MarginRightSpan>
        {unassigned}/{quantity}
      </MarginRightSpan>
      <MarginTopProgressBar
        value={(unassigned / quantity) * 100}
        fullWidth={true}
      />
    </FlexCenteredContainer>
  );
}
